import {useQuery} from '@tanstack/react-query';
import {getInquiryInfo} from '@/api/help/my-inquiry';
import {OBJECTION_NODE_ID} from '@/constants/help';

export const useGetInquiryInfo = ({inquiryId}: {inquiryId: string}) => {
  return useQuery({
    queryKey: ['inquiryInfo', inquiryId],
    queryFn: () => getInquiryInfo({inquiryId}),
    select: ({data, errorCode}) => {
      return {
        isError: errorCode !== 0,
        isMember: data.loginFlag,
        isObjection: data.nodeId === OBJECTION_NODE_ID,
      };
    },
  });
};
